import React from "react";

function Mail() {
  return <h2>Mailbox</h2>;
}

export default Mail;
